import React from 'react';
import { useLocation } from 'react-router-dom';
import '../css/Stepper.css';

const steps = ['Dates', 'Rooms', 'Contact', 'Confirm'];
const stepPaths = ['/', '/room', '/contact', '/payment'];

export default function Stepper() {
  const location = useLocation();
  const currentStep = stepPaths.findIndex(path => location.pathname === path);

  return (
    <div className="stepper-wrapper mb-4">
      <div className="stepper-bar d-flex align-items-center justify-content-between">
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isActive = index === currentStep;

          return (
            <div key={index} className="step-item d-flex align-items-center">
              <div
className={`step-circle ${
  isCompleted ? 'bg-white border border-secondary text-secondary' :
  isActive ? 'bg-black text-white' :
  'bg-white border border-light text-muted'
}`}


              >
                {index + 1}
              </div>
              <div className="step-label ms-2">{step}</div>
              {index < steps.length - 1 && (
                <div className="step-line ms-3 me-3 d-none d-sm-block">→</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
